
import React from 'react';
import { MOCK_TEAM } from '../constants';
import { Users, UserPlus, Mail, MoreVertical, Shield } from 'lucide-react';

const TeamManagement: React.FC = () => {
  return (
    <div className="p-4 lg:p-6 space-y-4 animate-fadeIn max-w-[1600px] mx-auto">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
        <div>
          <h1 className="text-xl font-black text-slate-900 tracking-tight leading-tight flex items-center gap-2">
            <Users className="text-[#e51b23] shrink-0" size={24} />
            Team Management
          </h1>
          <p className="text-xs text-slate-500 font-medium mt-1">Beheer toegangen voor recruiters en managers van Fleetconnect.</p>
        </div>
        <button className="flex items-center gap-2 bg-indigo-600 text-white px-5 py-2.5 rounded-lg font-black text-xs uppercase shadow-xl shadow-indigo-100">
          <UserPlus size={16} /> Lid Uitnodigen
        </button>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-slate-50 text-slate-400 text-[10px] font-black uppercase tracking-widest border-b border-slate-100">
              <tr>
                <th className="px-8 py-5">Medewerker</th>
                <th className="px-8 py-5">Rol</th>
                <th className="px-8 py-5">Datum Toegevoegd</th>
                <th className="px-8 py-5 text-right">Acties</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {MOCK_TEAM.map(member => (
                <tr key={member.id} className="hover:bg-slate-50 transition-colors">
                  <td className="px-8 py-6">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-md bg-indigo-50 flex items-center justify-center text-indigo-600 font-bold">
                        {member.name.charAt(0)}
                      </div>
                      <div>
                        <p className="text-sm font-bold text-slate-800">{member.name}</p>
                        <p className="text-[10px] text-slate-400 flex items-center gap-1"><Mail size={10} /> {member.email}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-8 py-6">
                    <span className="flex items-center gap-1.5 text-[10px] font-black text-indigo-600 uppercase tracking-widest bg-indigo-50 px-3 py-1 rounded-full border border-indigo-100">
                      <Shield size={10} /> {member.role}
                    </span>
                  </td>
                  <td className="px-8 py-6 text-xs text-slate-400">{member.joinedAt}</td>
                  <td className="px-8 py-6 text-right">
                    <button className="p-2 text-slate-400 hover:text-slate-600 rounded-md">
                      <MoreVertical size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TeamManagement;
